// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__pmGDw","rootSuccess":"CompleteLink_rootSuccess__1q15q","rootFailure":"CompleteLink_rootFailure__2LKKr","isDisabled":"CompleteLink_isDisabled__2c7Jk"};